import React from 'react';
import { PrimaryButton } from '../../../../components';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import schoolBanner from './schoolBanner.png';
import css from './SectionSchoolHero.module.css';

function SchoolInlineBanner({ intl, onRedirectPage }) {
  return (
    <div className={classNames(css.howItWorks, css.brandInlineBanner)}>
      <div className={css.startContent}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>
              <FormattedMessage id="SchoolInlineBanner.title" />
            </h2>
            <p>
              <FormattedMessage
                id="SchoolInlineBanner.description"
                values={{
                  nilPremier: intl.formatMessage({
                    id: 'SchoolInlineBanner.nilPremier',
                  }),
                }}
              />
            </p>
            <PrimaryButton
              className={css.viewbtn}
              type="button"
              onClick={() => onRedirectPage('SubscriptionPage')}
            >
              <FormattedMessage id="SchoolInlineBanner.button" />
            </PrimaryButton>
          </div>
        </div>
      </div>
      <div className={css.endContent}>
        <img src={schoolBanner} alt="School Banner" className={css.schoolBanner} />
      </div>
    </div>
  );
}

export default SchoolInlineBanner;
